module.exports = __webpack_public_path__ + "Neoway-logo-azul.6dcabc4f.png";